// Polish labels for Template#category / Block#kind (admin block CRUD).

const BLOCK_KIND_LABELS_PL = {
  header: 'Nagłówki',
  footer: 'Stopki',
  carousel: 'Karuzele',
  features: 'Wyróżnienia',
  cta: 'CTA',
  content: 'Treść',
  layout: 'Układ',
};

const BLOCK_KIND_GENITIVE_PL = {
  header: 'nagłówka',
  footer: 'stopki',
  carousel: 'karuzeli',
  features: 'wyróżnień',
  cta: 'CTA',
  content: 'treści',
  layout: 'układu',
};

export function blockKindLabelPl(kind) {
  return BLOCK_KIND_LABELS_PL[kind] || 'Bloki';
}

export function blockKindGenitivePl(kind) {
  return BLOCK_KIND_GENITIVE_PL[kind] || 'bloku';
}
